import { useMutation } from '@tanstack/react-query'

import {
  TCreateOutreachPayloadError,
  TOfuSimulateContact,
  TOfuSimulatePayload,
} from '~/features/campaigns/models'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const simulateOfuCampaign = (payload: TOfuSimulatePayload) => {
  return HttpService.post<TOfuSimulateContact | TCreateOutreachPayloadError>(
    {
      path: EServerPath.simulateOfuCampaign,
      payload,
    },
    EHttpService.internal,
  ).then((res) => {
    return res.data ? res.data : res
  })
}

const useOfuSimulate = () => {
  const mutation = useMutation({
    mutationFn: (payload: TOfuSimulatePayload) => simulateOfuCampaign(payload),
  })

  return {
    ...mutation,
  }
}

export default useOfuSimulate
